import React, { Component } from 'react'
import { Upload, Icon, Modal } from 'antd'
import './PictureWall.css'
class PicturesWall extends Component {
  state = {
    previewVisible: false,
    previewImage: '',
    fileList: []
  }

  handleCancel = () => this.setState({ previewVisible: false })

  handlePreview = file => {
    this.setState({
      previewImage: file.signedUrl || file.url || file.thumbUrl,
      previewVisible: true
    })
  }

  handleChange = ({ fileList }) => {
    const { onFileListChange } = this.props
    onFileListChange(fileList)
  }
  beforeUpload = file => {
    /*
    this.setState(prevState => ({
      fileList: [...prevState.fileList, file]
    }))
    */

    return false
  }
  onRemove = file =>
    new Promise(resolve => {
      const { handleDeleteImage } = this.props
      Modal.confirm({
        title: 'Do you want to delete this image?',
        onOk() {
          handleDeleteImage(file.uid)
          resolve(true)
        },
        onCancel() {
          resolve(false)
        }
      })
    })

  render() {
    const { previewVisible, previewImage } = this.state
    const { selectedFilesList } = this.props

    const addImageButton = (
      <div>
        <Icon type="plus" />
        <div className="ant-upload-text">Add Image</div>
      </div>
    )

    return (
      <div className="clearfix">
        <Upload
          listType="picture-card"
          fileList={selectedFilesList}
          onPreview={this.handlePreview}
          onChange={this.handleChange}
          beforeUpload={this.beforeUpload}
          onRemove={this.onRemove}
        >
          {addImageButton}
        </Upload>
        <Modal
          visible={previewVisible}
          footer={null}
          onCancel={this.handleCancel}
          maskClosable={false}
        >
          <img alt="example" style={{ width: '100%' }} src={previewImage} />
        </Modal>
      </div>
    )
  }
}
export default PicturesWall



// WEBPACK FOOTER //
// ./src/containers/items/PictureWall.js